import { atom } from 'recoil';
import type { PatientConflict } from '~/hooks/patient/usePatientGuard';

/** What the patient-conflict dialog shows, and whether it is open. */
export type PatientConflictState = PatientConflict & { open: boolean };

/**
 * The one patient conflict the app is asking about. Every import asks through
 * this atom, and the single dialog the app mounts answers it, so no import
 * waits on a question that nothing renders.
 */
export const patientConflictState = atom<PatientConflictState>({
    key: 'patientConflictState',
    default: {
        open: false,
        loadedPatientIds: [],
        incomingPatientIds: [],
        hasUnsavedChanges: false,
        clinicalUse: true,
    },
});
